import { render, staticRenderFns } from "./CircularButton.vue?vue&type=template&id=6163def7&scoped=true&"
import script from "./CircularButton.vue?vue&type=script&lang=js&"
export * from "./CircularButton.vue?vue&type=script&lang=js&"
import style0 from "./CircularButton.vue?vue&type=style&index=0&id=6163def7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6163def7",
  null
  
)

export default component.exports